import React from 'react';
import { useVectorCapitalSimulator } from './VectorCapitalSimulatorContext';

export default function VectorCapitalFullLayout() {
  const sim = useVectorCapitalSimulator();

  if (sim.loading) {
    return (
      <div className="vector-capital-page">
        <div className="vector-capital-empty-state">Loading strategies...</div>
      </div>
    );
  }

  if (sim.error) {
    return (
      <div className="vector-capital-page">
        <div className="vector-capital-empty-state">
          <p>{sim.error}</p>
          <button type="button" className="vector-capital-secondary-btn" onClick={sim.fetchAnalytics}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="vector-capital-page">
      {sim.renderTopbar()}
      {sim.renderControls()}
      {sim.renderChart()}
      {sim.renderComparison()}
      {sim.renderCalendar()}
      {sim.renderMonthlyReturns()}
      {sim.renderTradesList()}
      {sim.renderKeyInsights()}
      {sim.renderGrowthCalculator()}
      {sim.renderDisclosures()}
    </div>
  );
}
